import SubSectionText from './SubSectionText';

export default SubSectionText; 